import React from "react";

const TrashCan: React.FC = () => {
  return (
    <div style={{ padding: "9px 10px 6px 10px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
      >
        <path
          d="M2.15687 3.25123V12.5326C2.15677 12.7977 2.20891 13.0602 2.31029 13.3051C2.41168 13.55 2.56033 13.7725 2.74775 13.9599C2.93517 14.1473 3.15768 14.296 3.40257 14.3973C3.64747 14.4987 3.90994 14.5509 4.17499 14.5508H9.82513C10.3602 14.5508 10.8733 14.3382 11.2516 13.9599C11.63 13.5816 11.8425 13.0684 11.8425 12.5334V3.25049M0.542969 3.25123H13.4571"
          stroke="black"
          strokeWidth="0.953592"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.57861 3.25118V2.04002C4.57861 1.881 4.60995 1.72354 4.67082 1.57663C4.7317 1.42973 4.82092 1.29626 4.9334 1.18385C5.04588 1.07145 5.1794 0.982301 5.32634 0.921515C5.47328 0.860729 5.63076 0.829493 5.78978 0.82959H8.21063C8.36965 0.829493 8.52713 0.860729 8.67407 0.921515C8.82101 0.982301 8.95454 1.07145 9.06701 1.18385C9.17949 1.29626 9.26872 1.42973 9.32959 1.57663C9.39047 1.72354 9.4218 1.881 9.4218 2.04002V3.25118M5.38631 11.3926V7.35862M8.61485 11.3926V7.35862"
          stroke="black"
          strokeWidth="0.953592"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default TrashCan;
